import JSONAPIClient from '../JSONAPIClient'

JSONAPIClient.define('metadatum', { document_types: [] })
